export const SLACK_MEMBER_ID_CLAIM_NAME = "SlackMemberID";
export const SLACK_MEMBER_ID_CLAIM_VALUE = "slack_member_id";
export const SLACK_MEMBER_ID_CLAIM_MAPPING = {
  entries: [{ name: SLACK_MEMBER_ID_CLAIM_NAME, value: SLACK_MEMBER_ID_CLAIM_VALUE }],
};
export const SLACK_MEMBER_ID_CLAIM_MAPPING_EMPTY = { entries: [] };
